import { useState } from "react"
import styled from "styled-components"
import { Button, LoadingIcon, Modal } from "@prosolve/common-components-ui"
import EventResourcesEditor from "./EventResourcesEditor"
import useDataEvents from "../../../../dataHooks/useDataEvents"
import useSnackbar from "../../../../hooks/useSnackbar"

const FullScreenOverlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(184, 184, 184, 0.2);
  z-index: 900000;
`

export default ({
  eventData,
  onClose,
  onSuccess,
}) => {
  const {
    resources: defaultResources
  } = eventData || {}

  const [resources, setResources] = useState(defaultResources)

  const snackbar = useSnackbar()
  
  const {
    isLoading,
    updateEvent,
  } = useDataEvents();

  const showError = (message) => {
    snackbar.newMessage({ message, severity: 'failure' })
  }

  const onSubmit = async (data) => {
    try {
      const submitData = { ...data, id: eventData.id }
      await updateEvent(submitData)
      onSuccess(submitData)
    } catch (e) {
      showError('Error saving resources')
      console.log(e)
    }
  }

  const onClickSubmit = () => {
    const newEventData = {
      ...eventData,
      resources
    }
    onSubmit(newEventData)
  }

  const onUpdateResources = (newResources) => {
    setResources(newResources)
  }

  return (
    <>
      {isLoading && 
        <FullScreenOverlay>
          <LoadingIcon style={{ paddingRight: '10px' }} />
        </FullScreenOverlay>
      }
      <Modal title='Edit Resources' isAutoHeight={true} onClose={onClose} footer={(
        <div style={{ 
          position: 'relative',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          columnGap: '10px',
          padding: '10px'
        }}>
          <Button onClick={onClose}>
            {'Cancel'}
          </Button>
          <Button onClick={onClickSubmit} $colored={true}>
            {'Confirm'}
          </Button>
        </div>
      )}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          rowGap: '15px',
          height: '100%',
          position: 'relative'
        }}>
          <EventResourcesEditor resources={resources} onUpdate={onUpdateResources} />
        </div>
      </Modal>
    </>
  )
}